import React, { useState } from "react";
import { FaInfo } from "react-icons/fa";
import InfoPopup from "./InfoPop";
import "../assets/css/infobutton.css";

const InfoButton = ({ notes }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className="info-btn"
        style={{
          cursor: `url("/cursor/np_touch_5003891_0000002x.png") 8 8, pointer`,
        }}
      >
        <FaInfo />
      </button>

      <InfoPopup open={isOpen} onClose={() => setIsOpen(false)} notes={notes} />
    </>
  );
};

export default InfoButton;
